import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AboutComponent from "../components/about_component";
import { updateUser } from "../actions";

const mapStateToProps = state => (state.user);

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({updateUser}, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutComponent);
